import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import PassCreateEditForm from './Components/PickupPassesCreateEditForm';
import PassApi from './PickupPassesApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: PassCreateEditForm,
                getCreate: PassApi.create,
                defaults: {},
                successMessage: "Pass Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}